/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PncSeveralFullLotNumberModalComponent} from './pnc-several-full-lot-number-modal.component';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {TooltipModule} from '../../../../shared/tooltip/tooltip.module';
import {PncFullLotNumberChipModule} from './pnc-full-lot-number-chip/pnc-full-lot-number-chip.module';

@NgModule({
    declarations: [PncSeveralFullLotNumberModalComponent],
    imports: [
        CommonModule,
        GenericModalModule,
        TooltipModule,
        PncFullLotNumberChipModule
    ],
    exports: [PncSeveralFullLotNumberModalComponent]
})
export class PncSeveralFullLotNumberModalModule {
}
